// test127
(127 && 0);
